<template>
  <div class="enterprise">
    <router-view></router-view>
    <ContentView v-if="isDetail==false">
      <template slot="operateLeft">
        <el-button size="small" @click="addUser">添加用户</el-button>
        <el-input style="margin-left:10px" class="enter-input" v-model="searchVal" size="small" clearable placeholder="请输入姓名" @keyup.enter.native="onSearch"></el-input>
        <el-select
          @change="onSelect"
          class="enter-input"
          size="small" 
          clearable
          v-model="orgCode"
          filterable
          placeholder="筛选企业"
        >
          <el-option
            v-for="item in orgList"
            :key="item.orgCode"
            :label="item.orgName_Short"
            :value="item.orgCode"
          ></el-option>
        </el-select>
        <el-select
          v-if="orgCode"
          @visible-change="roleVisible"
          @change="onRoleChange"
          class="enter-input"
          size="small" 
          clearable
          v-model="roleID"
          filterable
          placeholder="筛选角色"
        >
          <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.roleName"
            :value="item.id"
          ></el-option>
        </el-select>
        
      </template>
      <template slot="operateRight"></template>
      <el-table
        class="account-table"
        slot="contentBox"
        :data="tableData"
        v-loading="loading"
        border
        height="100%"
        @row-click="onDetail"
        @sort-change="onTbaleSort"
        style="width: 100%"
      >
        <el-table-column label="NO" align="center" width="60">
          <template slot-scope="scope">
            <span>{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Logo" label="头像" width="100">
          <template slot-scope="scope">
            <el-image class="org-logo" :src="scope.row.photo">
              <div slot="error" class="image-slot">
               <img class="org-logo" src="https://oss.sgitns.com/defaultimages/user1.png" alt="">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" prop="realName"  label="姓名"></el-table-column>
        <el-table-column sortable="custom" prop="userName" label="手机号" width="140"></el-table-column>
        <el-table-column sortable="custom" prop="orgName_Short" label="所属企业" width="200"></el-table-column>
        <el-table-column sortable="custom" prop="roleName" label="角色"></el-table-column>
        <el-table-column prop="registerDate" sortable="custom" width="110" label="注册日期"></el-table-column>
        <el-table-column prop="loginTime" sortable="custom" label="最近登录"></el-table-column>
        <el-table-column prop="ip"  label="IP"></el-table-column>
        <el-table-column prop="userState" width="90" label="状态">
          <template slot-scope="scope">
            <el-tag  :type="tagType[scope.row.userState]">{{sjConfig.userState[scope.row.userState]}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="" @click.prevent.stop="navTo(scope.row)">登录</el-button>
            <el-button type="text" class="" @click.prevent.stop="onOffline(scope.row)">强制下线</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="pagnation">
        <el-pagination
          background
          @size-change="pageSizeChange"
          @current-change="pageCurrentChange"
          :page-sizes="[15, 20, 30, 50]"
          :page-size="15"
          layout="sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </template>
    </ContentView>
    <el-dialog title="帐户详情" :visible.sync="dialogFormVisible"></el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import ContentView from "@/components/ContentView";
import apiPub from "@/api/public";
import md5 from "js-md5";
export default {
  name: "enterprise",
  data() {
    return {
      form: {},
      dialogFormVisible: false,
      formLabelWidth: "80px",
      tableData: [],
      options: [],
      tagType:{
        '1':'success',
        '2':'warning',
        '0':'danger',
        '3':'danger'
      },
      searchVal:"",
      orgList: [],
      roleList:[],
      roleID:"",
      orgCode:"",
      isDetail: false,
      input: "",
      win: false,
      loading:false,
      timesRun: 0,
      pageNum:15,
      OrdFild:"loginTime",
      OrdSort:"desc",
      page:0,
      total:0
    };
  },
  components: {
    ContentView
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      this.controlRouter(to.name);
      if (to.name == 'account') {
         this.onSearch()
      }
    }
  },
  created() {
    this.onSearch();
    this.getOrg();
    
    this.controlRouter(this.$router.currentRoute.name);
  },
  methods: {
    //---------------查询区域--------begin-----------
    init(orgCode){
      const that=this;
      $http.request({
         url:apiPub.GetOrgRoleList,
         data:{
          OrgCode:orgCode||this.currentUser.orgCode
         }},false, function(res) {
        if (res.code == 200) {
          that.roleList = res.data;
        }
      });
    },
    roleVisible(e){
      // if(e==true){
        
        if(!this.orgCode){
           this.$message({
                message: '请先选择企业',
                type: 'warning'
            });
          return;
        }
      // }
      // console.log(e)
    },
    onSearch(){
      this.page = 1;
      this.total = 0;
      this.getlist();
    },
    onSelect(e){
       this.getlist(e);
       this.roleID="";
       this.init(this.orgCode)
       
    },
    onRoleChange(e){
      this.getlist(e);
    },
    searchOrg(query) {
      // console.log(query)
      var that = this;
      if (query !== ''&&this.loading==false) {
        this.loading = true;
      var obj = {
        url: apiPub.GetAllEnterprise,
        data: {
          SearchText: query,
          pageNum: 0,
          pageSize: 10000,
        }
      };
      $http.request(obj, false, function(res) {
        // console.log(res);
        var arr=[]
        res.data.forEach(el=>{
          arr.push({
            label:el.orgName,
            value:el.orgCode
          })
        }); 
        that.orgList = arr;
        that.loading = false;
      },function(res){
         
      });
      }
    },
    //---------------业务区域--------end-----------
    controlRouter(name) {
      if (name != "account") {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    handleChange() {},
    //---------------表格操作--------begin-----------
    getlist(org) {
      var that = this;
      var SearchText=this.searchVal||"";
      this.loading = true;
      var data={
        pageNum: that.page - 1,
        pageSize: that.pageNum,
        SearchText:SearchText,
        OrdFild:that.OrdFild,
        OrdSort:that.OrdSort
      }
      if(this.orgCode){
        data.OrgCode=this.orgCode
      }
      if(this.roleID){
        data.Role=this.roleID
      }
      $http.request({ url: apiPub.UserPhoneBook,data:data}, false, function(res) {
        // console.log(res);
        that.tableData = res.data;
        that.total=res.totalNum;
        that.loading = false;
      },function(res){
        that.loading = false;
      });
    },
    addUser(){
      this.$router.push({
        path: "/account/AccountDetail"
      });
    },
    onDetail(e) {
      // console.log(e);
      this.$router.push({
        path: "/account/AccountDetail",
        query: { id: e.id,orgCode:e.orgCode}
      });
      return;
      $http.request(obj, false, function(res) {
        // console.log(res);
        // that.tableData=res.data;
      });
      this.dialogFormVisible = true;
    },
    getOrg(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetAllEnterprise,
        "data":{
          SearchText:SearchText,
          pageNum: 0,
          pageSize: 10000,
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.orgList=res.data;
      })
    },
    onOffline(data){
      console.log(data)
      var that=this;
      var obj = {
       "url": apiPub.MoNiRequest,
        "data":{
         staffid:data.id
        }
      };
      $http.request(obj,false,function(res) {
        if (res.code == 200) {
          if(res.info=='\"OK\"'){
            that.$message({
              message: '操作成功',
              type: 'success'
            });
          }else{
             that.$message({
              message: '操作失败',
              type: 'warning'
            });
          }
        }
      })
    },
    navTo(data){
      let baseurl = window.PLATFROM_CONFIG.baseUrl
      // console.log(data)
      var url='https://admin.sgitns.com'
      if(baseurl=='http://192.168.0.111:5003'){
        url='http://192.168.0.111:8088'
      }
      // window.open("https://admin.sgitns.com/#/cqxdwialogin?userName="+data.userName+"&p=Y3F4ZHdpYUAzMjE=&source=Console",'_blank')
      window.open(url+"/#/cqxdwialogin?userName="+data.userName+"&p=Y3F4ZHdpYUAzMjE=&source=Console",'_blank')
      return;
      // var psd=md5('cqxdwia@321').toUpperCase();
      var that=this;
      var obj = {
        "url": apiPub.Dev_Login,
        "data":{
          UserName: data.userName,
          PSD: psd
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        // window.open("https://admin.sgitns.com/#/cqxdwialogin?",'_blank')
        // that.orgList=res.data;
      })
    },
    onTbaleSort(e){
        // console.log(e)
        if(e.prop&&e.order){
          var sort={"descending":"desc","ascending":"asc"}
          this.OrdFild=e.prop;
          this.OrdSort=sort[e.order];
          if(e.prop=='orgName_Short'){
            this.OrdFild='orgCode'
          }
        }else{
          this.OrdFild="";
          this.OrdSort="";
        }
        this.page = 1;
        this.total = 0;
        this.getlist()
      },
    /// -----------------------分页--begin-----------------------------
    pageSizeChange(val) {
      var pageNum = `${val}`;
      this.pageNum = parseInt(pageNum);
      this.getlist();
    },
    pageCurrentChange(val) {
      var page = `${val}`;
      this.page = parseInt(page);
      this.getlist();
    },
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.account-table /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input {
  width: 200px;
}
.enter-input + .enter-input {
  margin-left: 15px;
}
.left-tab-menu {
  height: 100%;
}
.left-tab-menu ul {
  width: 300px;
  height: inherit;
  /* padding-left: 10px; */
  /* padding: 10px; */
  background-color: #fff;
  border: 1px solid #e9e9e9;
  margin-right: 15px;
}
.left-tab-menu li {
  list-style: none;
  line-height: 42px;
  font-size: 14px;
  cursor: pointer;
  padding: 0 14px;
}
.left-tab-menu .active {
  background-color: #23b9ff;
  color: #fff;
}
.tab-menu-title {
  line-height: 42px;
  padding: 0 14px;
  background-color: #fff;
  border-bottom: 1px solid #f0f0f0;
  margin-right: 15px;
}
.el-form-item {
  margin-bottom: 10px;
}
</style>
